module.exports = "/_next/static/images/congratulation-paper-background-7c270e202883ac5b915713a4b9b9cd14.png";